import AccordionTab from './AccordionTab'

export default AccordionTab
